import $ from 'jquery'

import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  connect() {
    const buyButton = document.getElementById('buy-button')
    const sellButton = document.getElementById('sell-button')
    const addOrderButton = document.getElementById('legg-inn-ordre-button')

    const handleFocus = function (button) {
      const clsAdd =
        button.id === 'buy-button'
          ? ['bg-green-300', 'hover:bg-green-500']
          : ['bg-pink-300', 'hover:bg-pink-500']
      const clsRemove =
        button.id === 'buy-button'
          ? ['bg-pink-300', 'hover:bg-pink-500']
          : ['bg-green-300', 'hover:bg-green-500']
      addOrderButton.classList.add(...clsAdd)
      addOrderButton.classList.remove(...clsRemove)
      button.classList.add(
        'is_active',
        `${button.id === 'buy-button' ? 'bg-green-300' : 'bg-pink-300'}`
      )
      button.classList.remove('is_inactive', 'bg-white')
    }

    const handleBlur = function (button) {
      button.classList.add('is_inactive', 'bg-white')
      button.classList.remove(
        'is_active',
        `${button.id === 'buy-button' ? 'bg-green-300' : 'bg-pink-300'}`
      )
    }
    const setDefaultState = function (defaultButton, otherButton) {
      handleFocus(defaultButton)
      handleBlur(otherButton)
      $('#direction-field').val(defaultButton === buyButton ? 'BUY' : 'SELL')
    }

    // Set default state for BUY button
    setDefaultState(buyButton, sellButton)

    buyButton.addEventListener('click', function () {
      handleFocus(buyButton)
      handleBlur(sellButton)
      $('#direction-field').val('BUY')
    })

    sellButton.addEventListener('click', function () {
      handleFocus(sellButton)
      handleBlur(buyButton)
      $('#direction-field').val('SELL')
    })
  }
}
